import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js'
import WechatTemplateCard from './wechat_template_card.js'
import WechatTestPushModal from './wechat_test_push_modal.js'

const TEMPLATES_TYPE = {
  'WechatPushTemplate::Form': { tab: '表单', title: '表单', description: '用户提交表单时推送' },
  'WechatPushTemplate::Post': { tab: '消息', title: '消息', description: '发布消息时推送' },
  'WechatPushTemplate::TemplatePost': { tab: '模板通知', title: '模板通知', description: '发送模板通知时推送' },
  'WechatPushTemplate::OrganizationApplication': { tab: '组织申请', title: '组织申请', description: '有人申请加入组织时推送' },
  'WechatPushTemplate::Yaw::Flow': { tab: '流程处理', title: '流程处理', description: '流程有待办时推送' },
  'WechatPushTemplate::Yaw::HourglassTimer': { tab: '流程逾期', title: '流程逾期', description: '流程超时未处理时推送' }
}

function snapshotOf(item) {
  return JSON.stringify({
    template_id: item.template_id || '',
    template_fields: (item.template_fields || []).map((field) => ({
      key: (field.key || '').trim(),
      source: field.source || ''
    }))
  })
}

export default Vue.extend({
  components: {
    'settings-container': SettingsContainer,
    'wechat-template-card': WechatTemplateCard,
    'wechat-test-push-modal': WechatTestPushModal
  },
  props: {
    activeTab: {
      type: String
    }
  },
  data() {
    return {
      templates: [],
      selectedType: 'WechatPushTemplate::Form',
      wechatTemplates: [],
      templatesLoading: false,
      templatesError: '',
      testPushTemplate: null
    }
  },
  computed: {
    typeOptions() {
      return this.templates.map((item) => ({
        type: item.type,
        tab: item.tab,
        configured: !!(item.template_id && item.template_id.trim())
      }))
    },
    currentTemplate() {
      return this.templates.find((item) => item.type === this.selectedType) || null
    },
    selectedWechatTitle() {
      if (!this.currentTemplate || !this.currentTemplate.template_id) return ''
      const wechat = this.wechatTemplates.find((template) => (
        template.template_id === this.currentTemplate.template_id
      ))
      return wechat ? wechat.title : this.currentTemplate.template_id
    },
    mappedCount() {
      if (!this.currentTemplate) return 0
      return this.currentTemplate.template_fields.filter((row) => row.key && row.source).length
    },
    fieldCount() {
      if (!this.currentTemplate) return 0
      return this.currentTemplate.template_fields.filter((row) => row.key && row.key.trim() !== '').length
    },
    isDirty() {
      if (!this.currentTemplate) return false
      return snapshotOf(this.currentTemplate) !== this.currentTemplate._savedSnapshot
    }
  },
  created() {
    this.loadTemplates()
  },
  methods: {
    markSaved(item) {
      Vue.set(item, '_savedSnapshot', snapshotOf(item))
    },
    selectDefaultType() {
      const configured = this.templates.find((item) => item.template_id)
      this.selectedType = configured ? configured.type : 'WechatPushTemplate::Form'
    },
    loadTemplates() {
      Skylark.Libs.Ajax.get('/admin/settings/wechat_push_templates.json', {
        responseType: 'json',
        success: (data) => {
          this.templates = data.map((item) => {
            const template = Object.assign({}, item, TEMPLATES_TYPE[item.type] || {
              tab: item.type,
              title: item.type,
              description: ''
            })
            template.template_fields = (item.template_fields || []).map((field) => Object.assign({}, field))
            Vue.set(template, '_disabled', false)
            this.markSaved(template)
            return template
          })
          this.selectDefaultType()
          this.fetchWechatTemplates()
        },
        error: (xhr) => {
          Skylark.Bridge.newAlertify(this.errorMessage(xhr, '加载推送模板失败'), { type: 'danger' })
        }
      })
    },
    fetchWechatTemplates() {
      this.templatesLoading = true
      this.templatesError = ''
      Skylark.Libs.Ajax.get('/admin/settings/wechat_push_templates/wechat_templates.json', {
        responseType: 'json',
        success: (data) => {
          this.wechatTemplates = data.templates || []
        },
        error: (xhr) => {
          this.templatesError = this.errorMessage(xhr, '拉取模板列表失败')
        },
        complete: () => {
          this.templatesLoading = false
        }
      })
    },
    selectTemplate(item, templateId) {
      const wechat = this.wechatTemplates.find((template) => template.template_id === templateId)
      if (!wechat) return

      item.template_id = wechat.template_id
      item.template_fields = wechat.params.map((param) => {
        const existing = item.template_fields.find((row) => row.key === param.key)
        return { key: param.key, source: existing ? existing.source : '' }
      })
    },
    updateSettings(template) {
      template._disabled = true
      Skylark.Libs.Ajax.patch(`/admin/settings/wechat_push_templates/${template.id}.json`, {
        data: {
          wechat_push_templates: {
            template_id: template.template_id,
            template_fields: template.template_fields
              .filter((row) => row.key.trim() !== '' || row.source !== '')
              .map((row) => ({ key: row.key.trim(), source: row.source }))
          }
        },
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: (data) => {
          template.template_fields = (data.template_fields || []).map((field) => Object.assign({}, field))
          template.template_id = data.template_id
          this.markSaved(template)
          Skylark.Bridge.newAlertify('更新推送模板成功', { type: 'success' })
        },
        error: (xhr) => {
          Skylark.Bridge.newAlertify(this.errorMessage(xhr, '更新推送模板失败'), { type: 'danger' })
        },
        complete: () => {
          template._disabled = false
        }
      })
    },
    openTestPush(template) {
      this.testPushTemplate = template
    },
    errorMessage(xhr, fallback) {
      const errors = xhr.responseJSON && xhr.responseJSON.errors
      return errors && errors.length ? errors.join('；') : fallback
    }
  },
  template: `
    <settings-container :activeTab="activeTab">
      <template slot="content">
        <div class="push-template-page">
          <div class="push-template-toolbar">
            <div class="push-template-toolbar-copy">
              <h2 class="push-template-toolbar-title">推送模板</h2>
              <p class="push-template-hint">为每种业务消息选择微信模板并映射字段。进入页面会自动拉取公众号模板。</p>
            </div>
            <div class="push-template-toolbar-actions">
              <span v-if="wechatTemplates.length > 0" class="push-template-toolbar-meta">已拉取 {{ wechatTemplates.length }} 个</span>
              <button
                type="button"
                class="btn btn-primary"
                :disabled="templatesLoading"
                @click="fetchWechatTemplates"
              >
                {{ templatesLoading ? '拉取中…' : '拉取模板' }}
              </button>
            </div>
          </div>
          <p v-if="templatesError" class="push-template-error">{{ templatesError }}</p>

          <nav class="push-template-tabs" aria-label="消息类型">
            <button
              v-for="option in typeOptions"
              :key="option.type"
              type="button"
              class="push-template-tab"
              :class="{ 'is-active': option.type === selectedType, 'is-configured': option.configured }"
              @click="selectedType = option.type"
            >
              {{ option.tab }}
            </button>
          </nav>

          <div v-if="currentTemplate" class="push-template-type-summary">
            <p class="push-template-type-desc">{{ currentTemplate.description }}</p>
            <p class="push-template-type-meta">
              <span>已映射 {{ mappedCount }}/{{ fieldCount }}</span>
              <span v-if="isDirty" class="is-dirty">有未保存更改</span>
            </p>
          </div>

          <wechat-template-card
            v-if="currentTemplate"
            :item="currentTemplate"
            :wechat-templates="wechatTemplates"
            :wechat-title="selectedWechatTitle"
            :dirty="isDirty"
            @select-template="selectTemplate"
            @update="updateSettings"
            @test-push="openTestPush"
          />
        </div>

        <wechat-test-push-modal
          v-if="testPushTemplate"
          :template="testPushTemplate"
          :type-title="testPushTemplate.title"
          :wechat-title="selectedWechatTitle"
          @close="testPushTemplate = null"
        />
      </template>
    </settings-container>
  `
})
